import { configureStore } from "@reduxjs/toolkit";
import freezerReducer from "./freezerSlice";
import authReducer from "./authSlice";

export const store = configureStore({
  reducer: {
    freezer: freezerReducer,
    auth: authReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore ces actions pour la vérification de sérialisation
        ignoredActions: ["freezer/setSelectedProduct"],
      },
    }),
});

// Pour JavaScript, on peut simplement exporter le store
export default store;
